import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FormQua007Build } from './forms-build/form-qua007-build';

export class FormQua007 extends FormQua007Build {
    public CreateForm(formBuilder: FormBuilder): FormGroup {
        const formulario: FormGroup = formBuilder.group({
            id: [0, []],
            offline: true,
            safra: ['', []],
            cerar: ['', []],
            ordem_rw: ['', []],
            contrato_juridico: ['', []],
            numero_campo: ['', []],
            cooperante: ['', []],
            site_origem: ['', []],
            site_recebimento: ['', []],
            gleba: ['', []],
            hibrido_rnc: ['', []],
            geracao: ['', []],
            especie: ['', []],
            tipo_colheita: ['', []],
            umidade: ['', []],
            data_colheita: ['', []],
            termino_enchimento: ['', []],
            saida_campo: ['', []],
            tempo_espera_campo: ['', []],
            responsavel_liberacao_colheita: ['', []],
            ticket_n: ['', []],
            placa_carreta: ['', []],
            transportadora: ['', []],
            dt: ['', []],
            nfp_nota_fiscal: ['', []],
            chegada_patio: ['', []],
            tempo_percurso: ['', []],
            distancia_campo_km: ['', []],
            data_pesagem: ['', []],
            peso_bruto_kg: ['', []],
            peso_tara_kg: ['', []],
            peso_liquido_kg: [0, []],
            inicio_descarga: ['', []],
            tempo_espera_patio: ['', []],
            tempo_total_transporte: ['', []],
            carga_transbordo: ['', []],
            saida_sdc_transbordo: ['', []],
            reinicio_descarga_transbordo: ['', []],
            tempo_transbordo: ['', []],
            termino_descarga: ['', []],
            tempo_descarga: ['', []],
            linha_descarga: ['', []],
            status_wwb: ['', []],
            recobrimento_rolos: ['', []],
            controle_secagem: ['', []],
            secador_camara: ['', []],
            faixa_qualidade_genetica: ['', []],
            faixa_qualidade_fisica: ['', []],
            temperatura_maxima_trajeto: ['', []],
            temperatura_maxima_tempo: ['', []],
            faixa_azul_campo: ['', []],
            faixa_azul_umidade: ['', []],
            faixa_azul_temperatura: ['', []],
            faixa_azul_tempo: ['', []],
            faixa_azul_transbordo: ['', []],
            faixa_azul_geral: ['', []],
            created_by: ['', []],
            responsavel_lancamento: ['', []],
            desvio_observacoes: ['', []],
            semana_colheita_seq: ['', []],
            ultima_carga: ['', []],
            semana_colheita_data: ['', []],
            toneladas_horas_lanes: ['', []],
            apc_ligado: ['', []],
            lote_rw: ['', []],
            tempo_total_de_descarga: ['', []],
            peso_total_rw: ['', []],
            temperatura_recebimento: ['', []],
            umidade_recebimento: ['', []],
            amostra_seca_molhada: ['', []],
            nota_ardida: ['', []],

            houve_desvio_documentacao: ['', []],
            list_caixas: ['', []],
            safra_basica: ['', []],
            cerar_basica: ['', []],
            origem_negocio: ['', []],

        });
        return formulario;
    }
}
